import React from "react"
// import PropTypes from 'prop-types'
import Img from "gatsby-image"
import Styled from "styled-components"
import {getFixedGatsbyImage} from "gatsby-storyblok-image"
import {Heading2} from "@styles/text"

const MultipleMediaWithCaptionWrapper = Styled.div`
  flex-direction: column;
	
	& h2 {
    text-align: center;
  }

  & button {
    margin-right: 16px;

  }
`

function MultipleMediaWithCaption({title, images, hideTitle}) {
	return (
		<MultipleMediaWithCaptionWrapper hideTitle={hideTitle}>
			{!hideTitle && <Heading2>{title}</Heading2>}
			<List images={images} hideTitle={hideTitle} />
		</MultipleMediaWithCaptionWrapper>
	)
}

export default MultipleMediaWithCaption

// MultipleMediaWithCaption.propTypes = {
// 	title: PropTypes.string.isRequired,
// 	images: PropTypes.array.isRequired,
// }

// MultipleMediaWithCaption.defaultProps = {
// 	images: []
// }

const ListContainer = Styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  margin-top: ${props => (props.hideTitle ? "0px" : "40px")};
  margin-bottom: ${props => (props.hideTitle ? "0px" : "16px")};
  padding: 0px;
  & li {
    display: flex;
    justify-content: center;
    margin-top: ${props => (props.hideTitle ? "0px" : "40px")};
  }

  @media (min-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`

const ListItem = Styled.li`
  // margin-top: 40px;
`

function List({images, hideTitle}) {
	return (
		<ListContainer hideTitle={hideTitle}>
			{images.map((image, index) => {
				const fixedProps = getFixedGatsbyImage(image.filename, {
					width: 131,
					height: 60,
					toFormat: "webp"
				})

				return (
					<ListItem key={image.name}>
						<Img fixed={fixedProps} />
					</ListItem>
				)
			})}
		</ListContainer>
	)
}
